import React from "react";
import { useHistory, useLocation, Route, Switch } from "react-router-dom";
import Dashboard from "./Pages/Dashboard";
import MyRewards from "./Pages/MyRewards";
import RefferalCodesAndFriends from "./Pages/RefferalCodesAndFriends";
import RateAndRules from "./Pages/RateAndRules";
import DownloadBanners from "./Pages/DownloadBanners";

const AfterLogin = () => {
  const history = useHistory();
  const location = useLocation();  

  const menuItems = [
    { 
      icon: '/assets/bcimages/bcaffiliate/bc-affiliate-slider-icon-1.svg', 
      text: 'Dashboard', 
      route: '/affiliate' // Base route for Dashboard
    },
    { 
      icon: '/assets/bcimages/bcaffiliate/bc-affiliate-slider-icon-2.svg', 
      text: 'My Rewards', 
      route: '/affiliate/my-rewards'
    },
    // { 
    //   icon: '/assets/bcimages/bcaffiliate/bc-affiliate-slider-icon-3.svg', 
    //   text: 'Referral Codes & Friends', 
    //   route: '/affiliate/referral-codes-and-friends'
    // },
    // { 
    //   icon: '/assets/bcimages/bcaffiliate/bc-affiliate-slider-icon-4.svg', 
    //   text: 'Rate & Rules', 
    //   route: '/affiliate/rate-and-rules'
    // },
    // { 
    //   icon: '/assets/bcimages/bcaffiliate/bc-affiliate-slider-icon-5.svg', 
    //   text: 'Download Banners', 
    //   route: '/affiliate/download-banners'
    // },
  ];

  return (
    <div className="bc-affiliate-main-container">
      <h2 style={{ marginTop: "20px", marginBottom: "20px" }}>Affiliate</h2>

      {/* Menu List */}
      <div className="bc-affiliate-slider-top">
        <ul>
          {menuItems.map((item, index) => (
            <li
              key={index}
              className={
                location.pathname === item.route ? "active" : "" // Exact match for the active class
              }
              onClick={() => history.push(item.route)}
            >
              <img src={item.icon} alt={item.text} />
              {item.text}
            </li>
          ))}
        </ul>
      </div>

      {/* Render Components Based on Route */}
      <div className="bc-affiliate-content">
        <Switch>
          <Route exact path="/affiliate" component={Dashboard} /> {/* Ensure exact match for /affiliate */}
          <Route path="/affiliate/my-rewards" component={MyRewards} />
          {/* <Route path="/affiliate/referral-codes-and-friends" component={RefferalCodesAndFriends} />
          <Route path="/affiliate/rate-and-rules" component={RateAndRules} />
          <Route path="/affiliate/download-banners" component={DownloadBanners} /> */}
        </Switch>
      </div>
    </div>
  );
};

export default AfterLogin;
